import { Check, Star, Crown, Zap } from "lucide-react";
import "../styles/03-components/featuresSection.scss";

const basisFeatures = [
  "Zugang zu ihrem Profil im Web",
  "Verifizierung Badges",
  "Pflege Persönlicher Informationen",
  "Gegenvorschlag machen",
];

const premiumFeatures = [
  "Buchungstool Integration",
  "Eigene Ranking Listen",
  "Treuekarte & Punkte sammeln",
  "Webseiten verlinkung im Profil",
  "Push für freie Bahnen ",
];

export const FeaturesSection = () => {
  return (
    <section className="features-section">
      <div className="features-container">
        <div className="features-header">
          <h2 className="features-title">
            Coming
            <span className="title-highlight"> Soon</span>
          </h2>
          <p className="features-description">
            Unser Business Portal befindet sich derzeit in der Entwicklung.
          </p>
        </div>

        {/*  <div className="features-grid">
          
          <div className="feature-card basis-card">
            <div className="card-header">
              <div className="icon-wrapper">
                <div className="icon-container basis-icon">
                  <Zap className="icon" />
                </div>
              </div>
              <div className="badge outline-badge">Kostenlos</div>
              <h3 className="card-title">Basis</h3>
              <div className="price">
                0€
                <span className="price-period">/Monat</span>
              </div>
            </div>

            <div className="card-content">
              <ul className="features-list">
                {basisFeatures.map((feature, index) => (
                  <li key={index} className="feature-item">
                    <Check className="check-icon" />
                    <span className="feature-text">{feature}</span>
                  </li>
                ))}
              </ul>

              <button className="cta-button outline-button">
                Kostenlos starten
              </button>
            </div>
          </div>

          
          <div className="feature-card premium-card">
            <div className="popular-badge">
              <div className="badge turquoise-badge">
                <Crown className="badge-icon" />
                Cooming Soon
              </div>
            </div>

            <div className="card-header">
              <div className="icon-wrapper">
                <div className="icon-container premium-icon">
                  <Crown className="icon" />
                </div>
              </div>
              <div className="badge turquoise-badge">Premium</div>
              <h3 className="card-title">Premium</h3>
              <div className="price">
                9,99€
                <span className="price-period">/Monat</span>
              </div>
            </div>

            <div className="card-content">
              <ul className="features-list">
                {premiumFeatures.map((feature, index) => (
                  <li key={index} className="feature-item">
                    <Check className="check-icon" />
                    <span className="feature-text">{feature}</span>
                  </li>
                ))}
              </ul>

              <button className="cta-button turquoise-button">
                <Star className="button-icon" />
                In die Warteliste
              </button>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};
